const FACESHAPE_PAYWALL_URL = "/faceshape-3month-29";

export const buildFaceshapeUserPhotoContinueUrl = ({
  search = "",
  queuedJobId = "",
} = {}) => {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  const hasUserImage = Boolean((params.get("img") || params.get("image") || "").trim());

  params.delete("utm_ab");

  if (queuedJobId && hasUserImage) {
    params.set("facemesh_job_id", queuedJobId);
  } else {
    params.delete("facemesh_job_id");
  }

  const queryString = params.toString();
  return queryString ? `${FACESHAPE_PAYWALL_URL}?${queryString}` : FACESHAPE_PAYWALL_URL;
};
